const AllFeedback = () => import("./views/AllFeedback.vue");
const AllFeedbackLogs = () => import("./views/AllFeedbackLogs.vue");
const ViewFeedbackList = () => import("./views/ViewFeedbackList.vue");
const FeedbackFormCreate = () => import("./views/FeedbackFormCreate.vue");
const FeedbackSettings = () => import("./views/FeedbackSettings.vue");
const FeedbackSurveySettings = () =>
  import("./views/FeedbackSurveySettings.vue");

const SurveyAssignToEmployee = () =>
  import("./views/SurveyAssignToEmployee.vue");

const CreateNewSurvey = () => import("./views/CreateNewSurvey.vue");

export default [
  {
    path: "view-all",
    component: AllFeedback,
  },
  {
    path: "archived",
    component: AllFeedback,
  },
  {
    path: "view-feedback-log",
    component: AllFeedbackLogs,
  },
  {
    path: "create",
    component: FeedbackFormCreate,
  },
  {
    path: "view/:id",
    component: ViewFeedbackList,
  },
  {
    path: "edit/:id",
    component: FeedbackFormCreate,
  },
  {
    path: "settings",
    component: FeedbackSettings,
  },
  {
    path: "settings/survey-settings",
    component: FeedbackSurveySettings,
  },
  {
    path: "settings/survey-assign",
    component: SurveyAssignToEmployee,
  },
  {
    path: "settings/create-survey",
    component: CreateNewSurvey,
  },
];
